'use strict';

import Loader from '../loader/loader';
import '../../_assets/abbott/js/_modernizr';
import { isFieldEmpty, isValidEmail, displayErrors } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class AdminNewAccount {
    constructor() {
        let $body = $('body'),
            $adminNewAccountDropdown = $('.admin-new-account__dropdown'),
            $firstName = $('#NewAdminFirstName'),
            $lastName = $('#NewAdminLastName'),
            $salesRepId = $('#NewAdminSalesRepId'),
            $region = $('#NewAdminRegion'),
            $state = $('#NewAdminState'),
            $primaryNumber = $('#NewAdminPrimaryNumber'),
            $emailAddress = $('#NewAdminEmailAddress'),
            $role = $('#NewAdminRole'),
            $stream = $('#NewAdminStream'),
            loader = new Loader(),
            _isInvalid = [],
            dataParams = {};

        $('.js-add-new-admin').on('click', function (e) {
            e.preventDefault();

            $adminNewAccountDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });

        $('.js-create-new-admin').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            _isInvalid = [];

            if (isFieldEmpty($firstName)) {
                $firstName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($lastName)) {
                $lastName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (!isFieldEmpty($salesRepId) && isFieldEmpty($region)) {
                $region
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($state)) {
                $state
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($emailAddress) || !isValidEmail($emailAddress.val())) {
                $emailAddress
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($role)) {
                $role
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                _isInvalid.push(0);
            }

            // if (isFieldEmpty($stream)) {
            //     $stream
            //         .parent().addClass('incomplete')
            //         .find('.error').slideDown({
            //             duration: 500,
            //             easing: 'easeOutExpo',
            //             queue: false
            //         });

            //     _isInvalid.push(0);
            // }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                loader.fadeIn();
                $(this).removeClass('error');
            }


            dataParams = {
                "Details":{
                    "FirstName": isFieldEmpty($firstName) == true ? null : $firstName.val(),
                    "LastName": isFieldEmpty($lastName) == true ? null : $lastName.val(),
                    "SalesRepId": isFieldEmpty($salesRepId) == true ? null : $salesRepId.val(),
                    "RegionId": isFieldEmpty($region) == true ? null : $region.val(),
                    "State": isFieldEmpty($state) == true ? null : $state.val(),
                    "MobilePhoneNumber": isFieldEmpty($primaryNumber) == true ? null : $primaryNumber.val(),
                    "EmailAddress": isFieldEmpty($emailAddress) == true ? null : $emailAddress.val(),
                    "RoleId": isFieldEmpty($role) == true ? null : $role.val(),
                    "StreamId": isFieldEmpty($stream) == true ? null : $stream.val()
                }
            };

            $.ajax({
                url: '/api/abbotadmins/create',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'POST',
                headers: { __RequestVerificationToken: $('#new-abbott-admin-form').find('input[name=__RequestVerificationToken]').val() },
                data: JSON.stringify(dataParams),
                success: function (data) {
                    toaster('Account details has been saved!');
                    window.location.href = data.href;
                   
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });

                    $('.js-collapse-form-modal').trigger('click');
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });

        });
    }
}
